package com.essntl.features.tag.data.supabase

import com.essntl.features.tag.domain.model.TagModel
import kotlinx.serialization.json.JsonElement
import kotlinx.serialization.json.JsonPrimitive

internal fun TagModel.toRequestMap(): Map<String, JsonElement> {
    val requestMap = mutableMapOf<String, JsonElement>()

    requestMap["name"] = JsonPrimitive(name)

    return requestMap
}
